module.exports = __webpack_public_path__ + "img/navbar.80a71830.jpg";